import type {
  ReportHistoryEntryType,
  ReportHistoryStatusUnionType,
} from '@api';

const REVIEWABLE_STATUSES: ReportHistoryStatusUnionType[] = [
  'READY_RESET',
  'FAILED_GENERATION',
  'FAILED_SEND',
];

export const isReportHistoryEntryReviewable = (
  entry: Pick<ReportHistoryEntryType, 'status' | 'reviewedAt'>
): boolean =>
  entry.reviewedAt === null && REVIEWABLE_STATUSES.includes(entry.status);
